export const clamp01 = (v) => Math.max(0, Math.min(1, isFinite(v) ? v : 0));

export const lerp = (a, b, t) => a + (b - a) * clamp01(t);

export const sigmoid = (x, k, threshold) =>
    1 / (1 + Math.exp(k * (x - threshold)));

export const sigmoidInv = (y, k, threshold) => 1 - sigmoid(y, k, threshold);

export const remap = (v, aMin, aMax, bMin, bMax) =>
    bMin + ((v - aMin) * (bMax - bMin)) / (aMax - aMin);
